module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "forum-category-preview"
  }, [_c('router-link', {
    staticClass: "category-header",
    attrs: {
      "to": _vm.categoryUrl
    }
  }, [_c('div', {
    staticClass: "category-meta"
  }, [_c('h2', [_vm._v("\n                " + _vm._s(_vm.category.label) + "\n            ")]), _vm._v(" "), (_vm.category.summary) ? _c('div', {
    staticClass: "summary"
  }, [_vm._v("\n                | " + _vm._s(_vm.category.summary) + "\n            ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "thread-count"
  }, [(_vm.threadCount !== null) ? _c('span', [_vm._v("\n                    " + _vm._s(_vm.formattedThreadCount) + "\n                ")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "img-wrapper"
  }, [(_vm.category.bannerUrl) ? _c('img', {
    attrs: {
      "src": _vm.category.bannerUrl
    }
  }) : _c('img', {
    attrs: {
      "src": require("../../../assets/img/ttto-thumbnail.jpg")
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "category-body"
  }, [_c('ForumThreadList', {
    attrs: {
      "sortable": true,
      "sortOrder": _vm.sortOrder,
      "threads": _vm.threads
    },
    on: {
      "update:sort-order": function($event) {
        _vm.sortOrder = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "category-link"
  }, [_c('router-link', {
    attrs: {
      "to": _vm.categoryUrl
    }
  }, [_vm._v("\n                View All\n            ")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4a03059e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/reusable/forum/category-preview.vue
// module id = 2011
// module chunks = 2